import { MULTI_MODALITY_TYPE } from '../../enums/model.enums';
import { isUndefined } from 'util';
export class MultiModalityPreference {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param id
     * @param type
     * @param minValue
     * @param maxValue
     * @param active
     */
    constructor(id, type, minValue, maxValue, active) {
        this._id = id;
        this._type = type;
        this._minValue = minValue;
        this._maxValue = maxValue;
        this._active = active;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {Mot}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.id = values.id || 0;
        sanitizedValues.type = values.type || MULTI_MODALITY_TYPE.TAXI;
        sanitizedValues.minValue = values.minValue || 0;
        sanitizedValues.maxValue = values.maxValue || 0;
        sanitizedValues.active = !isUndefined(values.active) ? values.active : false;
        return new MultiModalityPreference(sanitizedValues.id, sanitizedValues.type, sanitizedValues.minValue, sanitizedValues.maxValue, sanitizedValues.active);
    }
    /**
     * gets the id
     * @returns {number}
     */
    get id() {
        return this._id;
    }
    /**
     * sets the id
     * @param value
     */
    set id(value) {
        this._id = value;
    }
    /**
     * gets the type
     * @returns {number}
     */
    get type() {
        return this._type;
    }
    /**
     * sets the type
     * @param value
     */
    set type(value) {
        this._type = value;
    }
    /**
     * gets the minimal range
     * @returns {number}
     */
    get minValue() {
        return this._minValue;
    }
    /**
     * sets the minimal range
     * @param value
     */
    set minValue(value) {
        this._minValue = value;
    }
    /**
     * gets the maximum range
     * @returns {number}
     */
    get maxValue() {
        return this._maxValue;
    }
    /**
     * sets the maximum range
     * @param value
     */
    set maxValue(value) {
        this._maxValue = value;
    }
    /**
     * gets the active state
     * @returns {boolean}
     */
    get active() {
        return this._active;
    }
    /**
     * sets the active state
     * @param value
     */
    set active(value) {
        this._active = value;
    }
}
//# sourceMappingURL=multiModalityPreference.js.map